import angular from "angular";
import { vsName as reportingModuleName } from "../../reporting";

import {
  vsServiceName as contactBookServiceName,
  ContactBookServiceProvider,
  ContactBookServiceRun,
} from "./ContactBookService";

import { vsModuleName as ContactBookSharedConfigModule } from "./configs/module";
export const vsModuleName = "SlotTrak.ContactBook.Shared";

angular
  .module(vsModuleName, [reportingModuleName, ContactBookSharedConfigModule, "ui.router"])
  .provider(contactBookServiceName, ContactBookServiceProvider)
  .run(ContactBookServiceRun);
